import { IModel, IAttribute, IViolation } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';

import { AzureCosmosDbV2Dataset } from 'app/model/dataset/azure-cosmos-db.v2.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.cosmosSql.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(AzureCosmosDbV2Dataset) }
})
export class AzureCosmosV2CopySource extends TabularCopySource {
    public static readonly MODEL: IModel;
    public static readonly PREFERRED_REGIONS: IAttribute;
    public static readonly PAGE_SIZE: IAttribute;
    public static readonly DETECT_DATE_TIME: IAttribute;
    public static readonly INCLUDE_SYSTEMCOLUMNS: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'PREFERRED_REGIONS',
        display: stringResources.ModelName_Preferred_Regions
    })
    public preferredRegions?: string[] = [];

    @Metamodel.attribute({
        templatable: true,
        association: 'PAGE_SIZE',
        display: stringResources.PageSizeLabel,
        constraint: {
            validator: (entity: {}, value: number): IViolation[] | undefined => {
                if (value <= 0 && value !== -1) {
                    return [
                        {
                            message: () => stringResources.PageSizeErrorMessage
                        }
                    ];
                }
                return undefined;
            }
        }
    })
    public pageSize?: number;

    @Metamodel.attribute({
        templatable: true,
        association: 'DETECT_DATE_TIME',
        display: stringResources.DetectDateTimeLabel
    })
    public detectDatetime?: boolean;
}
